import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { RootState, AppDispatch } from "app/store";
import { useScale } from "common/utils";
import Constants, { BASE_HEIGHT, BASE_WIDTH } from "common/constant";
import { actions } from "features/user/slice";
import { useSignUp } from "features/auth/hook";
import { AccountType } from "features/user/types";
import { Onboarding } from "./Onboarding";
import { UserSelection } from "./UserSelection";

const GuestScreen = () => {
  const { scale } = useScale();
  const navigate = useNavigate();
  const loading = useSelector((state: RootState) => state.config.loading);
  useEffect(() => {
    if (!loading) {
      navigate("/top", { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);
  return (
    <div className="flex-row-center w-full h-full bg-[#f8f1e8]">
      <div>
        <img
          alt="ローディング画像"
          src={`${Constants.assetHost}/assets/images/loading.gif`}
          style={{
            width: BASE_WIDTH * scale,
            height: BASE_HEIGHT * scale,
          }}
        />
      </div>
    </div>
  );
};

export const StartupScreen = () => {
  useSignUp();
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const users = useSelector((state: RootState) => state.user.users);
  const active = useSelector((state: RootState) => state.user.active);
  const parent = useSelector((state: RootState) => state.user.parent);

  useEffect(() => {
    if (parent?.account_type === AccountType.GUEST) {
      navigate("/top", { replace: true });
    } else if (users.length === 2 && active) {
      navigate("/top", { replace: true });
    } else {
      dispatch(actions.clearActiveUser());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return parent?.account_type === AccountType.GUEST ? (
    <GuestScreen />
  ) : (
    <div className="flex-col-el flex-center relative w-full h-full">
      <img
        alt="*"
        src={`${Constants.assetHost}/assets/images/new_bg_puzzle.png`}
        className="absolute inset-0 object-cover w-full h-full z-[-1]"
      />
      {parent ? <UserSelection /> : <Onboarding />}
    </div>
  );
};
